export default {
  root: {
    fontSize: '1rem',
  },
  colorDefault: {
    backgroundColor: '#edf1f3',
    color: '#3d464b',
  },
};
